<template>
  <BaseViewComponent
    name="offer"
    :is-preview="isPreview"
  >
    <div class="offer-wrapper full-width flex">
      <div class="text">
        <div class="title-h4 q-mb-sm offer-title">
          {{ pageData.offerTitle }}
        </div>
        <div class="text-p offer-text">
          {{ pageData.offerText }}
        </div>
      </div>
      <div class="timer flex flex-1 gap-md">
        <div class="flex items-center">
          <div class="digit-wrapper">
            {{ time.days }}
          </div>
          {{ $t('text.days') }}
        </div>
        <div class="flex items-center">
          <div class="digit-wrapper">
            {{ time.hours }}
          </div>
          {{ $t('text.hours') }}
        </div>
        <div class="flex items-center">
          <div class="digit-wrapper">
            {{ time.minutes }}
          </div>
          {{ $t('text.minutes') }}
        </div>
      </div>
      <div class="flex items-center">
        <BaseButton
          :label="pageData.offerButtonText"
          class="full-width"
        />
      </div>
    </div>
  </BaseViewComponent>
</template>

<script setup>
import BaseButton from 'components/book-landing/render/BaseButton.vue';
import { useBookPageStore } from 'stores/bookPage';
import { storeToRefs } from 'pinia';
import BaseViewComponent from 'components/book-landing/render/BaseViewComponent.vue';
import { useQuasar } from 'quasar';
import { computed, onUnmounted } from 'vue';

let intervalId;
const $q = useQuasar();

const props = defineProps({
  isPreview: {
    type: Boolean,
    default: false,
  },
});

const bookPageStore = useBookPageStore();
const { pageData, timerMinutes } = storeToRefs(bookPageStore);

const time = computed(() => ((
  props.isPreview
    ? pageData.value.offerDuration
    : {
      days: Math.floor(timerMinutes.value / 1440),
      hours: Math.floor((timerMinutes.value % 1440) / 60),
      minutes: Math.floor(timerMinutes.value % 60),
    }
)));
const offerMinutes = computed(
  () => (pageData.value.offerDuration.days || 0) * 1440 + (pageData.value.offerDuration.hours || 0) * 60 + (pageData.value.offerDuration.minutes || 0),
);

function checkTime() {
  timerMinutes.value -= 1;

  if (timerMinutes.value <= 0) {
    timerMinutes.value = offerMinutes.value;
  }
}

onUnmounted(() => {
  clearInterval(intervalId);
});

(async function () {
  if (!props.isPreview) {
    const timerStart = $q.cookies.get('offerTimerStart');

    if (timerStart) {
      const currentDate = new Date();
      const diff = Math.floor((currentDate - Date.parse(JSON.parse(timerStart))) / 60000);

      if (diff <= offerMinutes.value) {
        timerMinutes.value = offerMinutes.value - diff;
      } else {
        timerMinutes.value = offerMinutes.value;
        $q.cookies.set('offerTimerStart', new Date());
      }
    } else {
      $q.cookies.set('offerTimerStart', new Date());
      timerMinutes.value = offerMinutes.value;
    }

    intervalId = setInterval(checkTime, 60000);
  }
}());
</script>
